import { useParams, Navigate, Link } from "react-router-dom";
import { useSeo } from "@/lib/seo";
import { THEMES } from "@/data/themes";
import { ARTICLES } from "@/data/articles";
import { PageHeader } from "@/components/site/PageHeader";
import { ArticleCard } from "@/components/site/ArticleCard";
import { ContextualCTA } from "@/components/site/ContextualCTA";

const THEME_CATEGORIES = {
  "land-and-regulation": ["Land & Law", "Circle Rates"],
  locations: ["Location Intelligence"],
  "due-diligence": ["Due Diligence"],
  "planning-and-development": ["Master Plans"],
  "second-homes": ["Second Homes", "NRI Buyers"],
  "investment-research": ["Location Intelligence", "Buying in Uttarakhand"],
  "construction-and-ownership": ["Construction", "Hill Property"],
};

export default function ThemeDetail() {
  const { slug } = useParams();
  const theme = THEMES.find((t) => t.slug === slug);

  useSeo(
    theme
      ? { title: `${theme.title} — Intelligence`, description: theme.summary, path: `/intelligence/${slug}` }
      : { title: "Not found", path: `/intelligence/${slug}` }
  );

  if (!theme) return <Navigate to="/intelligence" replace />;

  const cats = THEME_CATEGORIES[slug] || [];
  let related = ARTICLES.filter((a) => cats.includes(a.category));
  if (related.length === 0) related = ARTICLES.slice(0, 3);

  return (
    <>
      <PageHeader
        eyebrow={`Intelligence · ${theme.index}`}
        marker="SS·INT"
        title={theme.title}
        intro={theme.summary}
        breadcrumbs={[{ label: "Intelligence", to: "/intelligence" }, { label: theme.title }]}
      />

      <section className="ss-container pb-12">
        <div className="max-w-3xl border-l-2 border-[#C2A374] pl-6 py-2">
          <p className="text-lg font-light leading-relaxed text-[#3a3f44]">{theme.detail}</p>
        </div>
      </section>

      <section className="ss-container pb-8">
        <h2 className="font-display text-3xl font-light text-[#1A1C1E] mb-10">Research in this theme</h2>
        <div className="grid md:grid-cols-3 gap-8 lg:gap-10">
          {related.map((a, i) => <ArticleCard key={a.slug} article={a} index={i} />)}
        </div>
      </section>

      <ContextualCTA
        eyebrow={theme.title}
        title="Have a question within this theme?"
        text="We can help you apply this intelligence to a specific location or property you're considering."
        whatsappMessage={`Hi Suhail, I have a question about ${theme.title.toLowerCase()} for a property in Uttarakhand.`}
      />
    </>
  );
}
